import React, { useState } from "react";
import { ModalProgressBar } from "../../../../../../../_metronic/_partials/controls";
import { shallowEqual, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import * as actions from "../../../../_redux/usersActions";
import { Notification } from "../../../../../../_components/Notification";
import { FormattedMessage } from "react-intl";
import { IUser, UserType } from "../../../../../../../data/schemas";
import { useAppSelector } from "../../../../../../../redux/hooks";
import { isEmpty } from "lodash-es";

interface SendAmlKycRequestModalProps {
  user: IUser;
  actionsLoading: boolean;
  showModal: boolean;
  setShowModal: Function;
}

export const SendAmlKycRequestModal: React.FC<SendAmlKycRequestModalProps> = ({
  user,
  actionsLoading,
  showModal,
  setShowModal,
}) => {
  const [notifyMethods, setNotifyMethods] = useState<Array<string>>([]);

  const { session } = useAppSelector(
    (state) => ({
      session: state.auth.session,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  const sendRequest = () => {
    const { protocol, host, port } = window.location;

    const userActionParams = {
      createdByUserId: session.id,
      userId: user.id,
      actionType: "FILLOUT_AML_KYC_FORM",
      messageDestinationTypes: notifyMethods,
      url: [`${protocol}//${host}`].join(`${port}`),
    };
    dispatch(actions.createUserAction(userActionParams));
    setShowModal(false);
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      aria-labelledby="user-request-info-modal"
      centered
      backdrop="static"
    >
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="request-kyc-aml-modal-title">
          <FormattedMessage id="USER.ACTION.REQUEST.FILLOUT.KYC_AML" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!actionsLoading && (
          <div className="form-group row">
            <div className="col-lg-12">
              <Notification
                userType={UserType.USER}
                setNotifyMethods={setNotifyMethods}
                notifyMethods={notifyMethods}
              />
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            className="btn btn-light btn-elevate"
            onClick={() => setShowModal(false)}
          >
            <FormattedMessage id="COMMON.ACTION.CANCEL" />
          </button>
          <button
            disabled={isEmpty(notifyMethods)}
            type="button"
            onClick={sendRequest}
            data-cy="button-user-action-confirm"
            className="btn btn-primary font-weight-bold ml-1"
          >
            <FormattedMessage id="COMMON.ACTION.REQUEST" />
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
